export default __webpack_public_path__ + "4c39874bc13aa5bb36fafbf0079e8f8f.png";